import React from 'react'
import './Testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const data=[
  {
    avatar: AVTR1,
    name:'Tina Snow',
    review: 'I am extremely impressed with the research and development services provided. The team demonstrated exceptional expertise in machine learning and AI, delivering innovative solutions that exceeded my expectations. Their in-depth analysis and customized approach significantly improved our project outcomes. Communication was clear, and they consistently met deadlines. I highly recommend their R&D services for anyone looking to push the boundaries of technology.'
  },
  {
    avatar: AVTR2,
    name:'Shatta Wale',
    review: 'I had an excellent experience working with the software development team. They were highly professional, delivered on time, and exceeded my expectations with the quality of the final product. The team was responsive to feedback and provided innovative solutions to the challenges we faced. The custom software they built has greatly improved our business operations. The team was highly rich in latest technologies and tools. I highly recommend their services.'
  },
  {
    avatar: AVTR3,
    name: 'Kwame Despite',
    review: 'We approached Hrithik and his team for a machine learning solution, and the results have been outstanding! Their team developed a custom model that significantly improved our data processing and predictions. The integration was seamless, and the insights we have gained have been invaluable to our business strategy. Their expertise in AI is top-notch, and we could not be less happier. Besides, the efficiency and working level is totally flawless. '
  },
  {
    avatar : AVTR4,
    name:'Nana Ama McBrown',
    review: 'I am extremely satisfied with the e-commerce project delivered. The team went above and beyond to create a smooth, user-friendly platform that exceeded my expectations. Their attention to detail and understanding of our business needs resulted in a site that is both functional and visually appealing. The entire process was seamless, and they were highly responsive to our feedback. I highly recommend them for anyone looking for top-notch development services.'
  },
]



const Testimonials = () => {
  return (
    <section id='testimonials'>
        <h5>Review From Clients</h5>
        <h2>Testimonials</h2>

        <Swiper className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        >
         {
          data.map(({avatar, name, review}, index)=>{
            return(
              <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src= {avatar} alt="" />
              </div>
              <h5 className='client__name'>{name}</h5>
                <small className='client__review'>
                  {review}
                </small>
            </SwiperSlide>
            )
          })
         }
        </Swiper>
    </section>
  )
}

export default Testimonials
